import moment from "moment";

class DateUtils {
    static generateYearList(backwardYear, forwardYear) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const dateList = [];
        for (let i = backwardYear; i > 0; i--) {
            const year = currentYear - i;
            const date = new Date(year, 0, 1);
            dateList.push(date.getFullYear());
        }

        for (let i = 0; i <= forwardYear; i++) {
            const year = currentYear + i;
            const date = new Date(year, 0, 1);
            dateList.push(date.getFullYear());
        }
        return new Set(dateList);
    }

    static formatDate(stringDate){
        const date = moment(stringDate);
        return date.format('DD-MM-YYYY');
    }

    static endOfToday(){
      const date =   new Date();
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      date.setMilliseconds(999);
      return date;
    }

}
export default DateUtils;
